import { Link } from "react-router-dom"

const NotFound = () => {
    return (
        <>
            <h2>Page not found!</h2>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum ea, officia repudiandae error eum laboriosam labore harum magnam nemo possimus sapiente cum a facilis iure eaque praesentium reprehenderit pariatur molestiae ab odio at rem perferendis? Quia itaque in voluptate ex molestias? Incidunt asperiores molestiae eos ad alias a cumque numquam.</p>
            <p>Go to the <Link to="/">Homepage</Link>.</p>
        </>
    )
}

export default NotFound